import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { adsRuntimeEnabled, ensureAdSession, getConsentState, isDeniedRoute, normalizeRoute, setConsentState } from "./ads";

export default function useAdsManager() {
  const location = useLocation();
  const route = useMemo(() => normalizeRoute(location.pathname), [location.pathname]);
  const [consent, setConsent] = useState(() => {
    if (typeof window === "undefined") return { accepted: false, decided: true };
    return getConsentState();
  });

  useEffect(() => {
    if (!adsRuntimeEnabled()) return undefined;
    ensureAdSession();
    return undefined;
  }, [route]);

  const acceptAds = () => {
    setConsentState(true);
    setConsent(getConsentState());
  };

  const declineAds = () => {
    setConsentState(false);
    setConsent(getConsentState());
  };

  return {
    route,
    consent,
    acceptAds,
    declineAds,
    adsEnabled: adsRuntimeEnabled(),
    adsDeniedOnRoute: isDeniedRoute(route)
  };
}
